import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import EnterTicketsPage from '../Components/Enter/EnterTicketsPage';
import { Redirect } from 'react-router-dom';

const EnterPage = ({ user, config, cmsSourceFirebase, actions, match }) => {
    const prepopTicket = new URLSearchParams(document.location.search).get('ticketnumber');

    const [scannedTicketSubmitted, setScannedTicketSubmitted] = useState(false);

    const [isLoading, setIsLoading] = useState(!!prepopTicket);

    const enterDrawTicketFromTicketNumberInUrl = useCallback(
        async (prepopTicket) => {
            if (prepopTicket) {
                await actions.drawTicketActions.enterDrawTicket({
                    ticket_number: prepopTicket,
                    entry_method: 'scan',
                });

                setScannedTicketSubmitted(true);
                setIsLoading(false);
            }
        },
        [actions.drawTicketActions]
    );

    useEffect(() => {
        enterDrawTicketFromTicketNumberInUrl(prepopTicket);
    }, [prepopTicket, enterDrawTicketFromTicketNumberInUrl]);

    if (isLoading) {
        return (
            <div className='loading-wrapper'>
                <div className='loading-overlay'>
                    <div className='loading-icon ellipses'></div>
                </div>
            </div>
        );
    }

    if (scannedTicketSubmitted) {
        return (
            <Redirect
                to={{
                    pathname: '/post-claim',
                    state: { motive: 'ScanTicket' },
                    motive: 'ScanTicket',
                }}
            />
        );
    }

    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <EnterTicketsPage />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(EnterPage);
